<template>
  <body>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li class="active">
            <a href="#" target="_self">
              Home
            </a>
          </li>
          <li class=" ">
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class=" ">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
    <div class="flexLayoutShop">
      <div class="leftSidebar">
        <div class="logoContainer">
          <a href="#"><img src="../../../assets/images/logo-white.svg" alt=""/></a>
        </div>
        <section class="sidebarBot">
          <div class="sideBotBod">
            <div class="sideBotFlexMenu">
              <li><a href="#">Home</a></li>
              <li><a href="#">Shop</a></li>
              <li class="active"><a href="#">Account</a></li>
            </div>
            <div class="sidePageTitle">
              <h1>Shop</h1>
            </div>
          </div>
        </section>
      </div>
      <div class="flexLayoutBody">
        <!-- <span class="pageTitleOnMobile">Account</span> -->
        <div class="mobileNavTop">
          <a @click="mixNav" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
          <div class="logoContainerMobile">
            <a href="#"><img src="../../../assets/images/logo-white.svg" alt=""/></a>
          </div>
          <a href="#" class="iconCartMobile openSidebar"
            ><img src="../../../assets/images/icon-cart.svg" alt=""
          /></a>
        </div>
        <div class="flexLayoutTop">
          <div class="flexLayoutShopFilter">
            <nav class="flexLayoutShopFilterActual">
              <li><router-link to="/user/account">Account Info</router-link></li>
              <li class="active"><router-link to="/user/profiles">Profiles</router-link></li>
              <li><router-link href="/user/orders">Orders</router-link></li>
              <li><a href="/#/logout">Sign Out</a></li>
            </nav>
          </div>
          <div class="flexLayoutTopRight">
            <a href="#" class="openSidebar"
              ><img src="../../../assets/images/icon-cart.svg" alt=""
            /></a>
          </div>
        </div>
        <div class="flexLayoutActualBody">
          <div class="userInfoInAccountContainer">
            <div class="itemBodyLeftModal notModal">
              <div class="trackContainer">
                <h2>Order Details</h2>
                <p>
                  To track your order please enter your Order ID in the box
                  below and press the "Track" button. This was given to you on
                  your receipt and in the confirmation email you should have
                  received.
                </p>
                <div class="individualInput">
                  <h5>Order ID</h5>
                  <input type="text" name="" id="" placeholder="" />
                </div>
                <div class="individualInput">
                  <h5>Account Email</h5>
                  <input type="text" name="" id="" placeholder="" />
                </div>
              </div>
              <div class="quickCheckout">
                <a href="#">Track</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
import states from '@/helpers/states'
export default {
  data() {
    return {
        showNav: false
    }
  },
  methods: {
    mixNav() {
        this.showNav = !this.showNav;
    }
  }
}
</script>
